import { ListSubheader, MenuItem, Select } from '@mui/material'
import { GuideNavigationChapterData } from './data/GuideNavigationChapterData'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useGetCurrentStep } from './hooks/useGetCurrentStep'

export interface GuideNavigationDropdownBlockProps {
  chapters: GuideNavigationChapterData[]
}

export const GuideNavigationDropdownBlock = ({
  chapters,
}: GuideNavigationDropdownBlockProps) => {
  const { t } = useTranslation()
  const history = useHistory()
  const currentStep = useGetCurrentStep(chapters)

  return (
    <Select
      fullWidth
      displayEmpty
      value={currentStep?.title ?? ''}
      renderValue={(value) =>
        value ||
        t('translation:guideWithNavigation.stepSelectionPlaceholderName')
      }
    >
      {chapters.map((chapter) => [
        <ListSubheader key={chapter.title} value={chapter.title}>
          {chapter.title}
        </ListSubheader>,
        ...chapter.steps.map((step) => (
          <MenuItem
            key={step.title}
            value={step.title}
            onClick={() => history.push(step.link)}
          >
            {step.title}
          </MenuItem>
        )),
      ])}
    </Select>
  )
}
